

exports.__esModule = true;
exports.$ThirdPartyInfoCollectFlowRoute = undefined;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ThirdPartyInfoCollectFlowRoute = exports.$ThirdPartyInfoCollectFlowRoute = _squid.$Route.extend('$ThirdPartyInfoCollectFlowRoute', {
    path: 'thirdPartyInfoCollectFlow',
    directive: _directive2['default'],
    query: ['payload_id'],

    auth: false,

    trackingData: {
        fptiState: 'third_party_info_collect'
    }
});

angular.value("$ThirdPartyInfoCollectFlowRoute", $ThirdPartyInfoCollectFlowRoute);
_squid.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-third-party-info/route.js
// module id = ./pages/xo-third-party-info/route.js
// module chunks = 0